<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
            <li><a href="#">首页</a></li>
            <li>短信</li>
            <li><a href="#">短信群发库</a></li>
            </ul>
        </div>
            
        <div class="formbody">
            
            <ul class="seachform mt20">
            
            <li><div>群发导入
                <el-upload
                    class="upload-demo"
                    ref="upload"
                    :on-success="uploadSuccess"
                    :action=smsContTxtUploadUrl
                    accept=".txt"
                    :auto-upload="false"
                    :headers="uploadHeaders">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传txt文件，且不超过500kb</div>
                </el-upload>
                </div>
            </li>

            </ul>
            
            <table class="tablelist">
                <thead>
                <tr>
                    <th>文件名</th>
                    <th>上传时间</th>
                    <th>联系人个数</th>
                    <th>查看</th>
                    <th>删除</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="(item,index) in smsContTxtList" :class="{odd:index%2!=0}">
                <td>{{item.filename}}</td>
                <td>{{item.createdate}}</td>
                <td>{{item.countnum}}</td>
                <td><a href="#" @click="showtxtcontent(item.id)">查看</a></td>
                <td><a href="#" @click="delsmsconttxt(item.id)">删除</a></td>
                </tr>
                
                
                </tbody>
            </table>
            
        
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
            
        
        <div class="jian">&nbsp;</div>

        
            </div> 
            
            
            <div class="tip">
                <div class="tiptop"><span>提示信息</span><a></a></div>
                
            <div class="tipinfo">
                <span><img src="images/ticon.png" /></span>
                <div class="tipright">
                <p>是否确认对信息的修改 ？</p>
                <cite>如果是请点击确定按钮 ，否则请点取消。</cite>
                </div>
                </div>
                
                <div class="tipbtn">
                <input name="" type="button"  class="sure" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" value="取消" />
                </div>
            
            </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{            
            pageIndex:0,
            totalCount:0,
            smsContTxtList:[],
            uploadHeaders:{},
            smsContTxtUploadUrl:this.GLOBAL.serverSrc + '/sms/uploadsmsconttxt.json',
        }
    },
    mounted(){
        this.uploadHeaders.token = this.GLOBAL.token;
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val);
        },
        handleCurrentChange(val) {
            this.pageChange(val);
        },
        pageChange(pageIndex){
            let that = this;
            let data = {'pageIndex':pageIndex,'pageSize':50};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/smsconttxt.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.smsContTxtList = res.data.smsContTxtList;
                    that.pageIndex = parseInt(pageIndex);
                    // that.pageCount = res.data.page.pageCount;
                    that.totalCount = res.data.page.totalCount;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        uploadSuccess(response){
            if (response.code === '0000000') {
                this.pageChange(1);
            }
            else if("0000006" == response.code){
                this.buttonDisabled = false
                this.$alert(response.message, '格式错误，文件必须是txt格式！', {
                    confirmButtonText: '确定'
                })
                this.$refs.upload.clearFiles()
            }
            else{
                alert(response.data.msg)
            }
        },
        submitUpload(){
            this.$refs.upload.submit();
        },
        showtxtcontent(id){
            window.open('/showsmstxtcontent?id=' + id,'newwindow','width=400,top=0,left=400')
        },
        delsmsconttxt(id){
            let that = this;
            let data = {'id':id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/delsmsconttxt.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("删除成功！");
                    that.pageChange(1);
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/sms/smsconttxt.vue